import { getOr } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getCurrentScopeProfileId } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { moduleSelector } from '../module';

export const isMessageModuleVisible = createSelector(moduleSelector, getOr(false, 'messageCenter.visible'));

export const getStubMessage = createSelector(getCurrentScopeProfileId, (profileId) => ({
    creatorProfileId: profileId,
    isStub: true,
    isFailed: false,
}));
